import { render, staticRenderFns } from "./ModeratorDropdown.vue?vue&type=template&id=4420bad2&"
import script from "./ModeratorDropdown.vue?vue&type=script&lang=ts&"
export * from "./ModeratorDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports